/**
 * Created by Alex Aguilar on 7/6/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('adminFlights',{
                parent: 'app',
                url: '/adminFlights?date&model&type',
                params: {
                    date: null,
                    model: "all",
                    type: "grid"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/adminFlight/adminFlights.html',
                        controller: 'adminFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminFlight','aircrew']);
                            }],
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            'modelAircraftFlights': ['modelAircraftService', '$stateParams',
                                function(modelAircraftService, $stateParams){
                                    if ($stateParams.date == null) {
                                        $stateParams.date = (new Date()).getTime();
                                    }

                                    if($stateParams.date != null && $stateParams.model == "all" && $stateParams.type == "grid"){
                                        return modelAircraftService.getModelAircraftFlights(parseInt($stateParams.date))
                                    }else{
                                        return [];
                                    }
                            }],
                            'modelAircrafts': ['modelAircraftService', function(modelAircraftService){
                                return modelAircraftService.getModelAircrafts()
                            }],
                            'aircraftFlights': ['aircraftService', '$stateParams', function(aircraftService, $stateParams){
                                if ($stateParams.date == null) {
                                    $stateParams.date = (new Date()).getTime();
                                }
                                if($stateParams.date != ""&& $stateParams.type == "grid"){
                                    return aircraftService.getAircraftFlights(parseInt($stateParams.date))
                                }else{
                                    return [];
                                }

                            }],
                            'flights': ['assignAirCrewService', '$stateParams', function(assignAirCrewService, $stateParams){
                                if ($stateParams.date == null) {
                                    $stateParams.date = (new Date()).getTime();
                                }
                                if($stateParams.date != ""&& $stateParams.type == "list"){
                                    return assignAirCrewService.getAssingAirCrewByDate(parseInt($stateParams.date))
                                }else{
                                    return [];
                                }

                            }]
                        }
                    }
                }
            })
            .state('adminFlightAll',{
                parent: 'app',
                url: '/adminFlightAll/:date/date',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/adminFlight/adminFlightAll.html',
                        controller: 'adminFlightAllCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminFlight']);
                            }],
                            'modelAircraftFlights': ['modelAircraftService', '$stateParams',
                                function(modelAircraftService, $stateParams){
                                    return modelAircraftService.getModelAircraftFlights(parseInt($stateParams.date))
                            }],
                            'aircraftFlights': ['aircraftService', '$stateParams', function(aircraftService, $stateParams){
                                return aircraftService.getAircraftFlights(parseInt($stateParams.date))
                            }]
                        }
                    }
                }
            })
            .state('adminFlight',{
                parent: 'app',
                url: '/adminFlight/:id/edit/:date/:type',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/adminFlight/adminFlightEdit.html',
                        controller: 'adminFlightEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            'loadForm': ['flightService', '$stateParams', function(flightService, $stateParams){
                                return flightService.getLoadForm($stateParams.id)
                            }],
                            'structures': ['structureSeatMapService', function(structureSeatMapService){
                                return structureSeatMapService.getStructuresByModelAircraft()
                            }]
                        }
                    }
                }
            })
    }
})();


